export default __webpack_public_path__ + "static/media/Chhattisgarhi_df_2.38be7bf8.mp3";